import fetchGql, { gql } from '../../util/fetchGql';
import Seo, { SEO_FRAGMENT } from '../../components/Seo';
import Article, { ARTICLE_FRAGMENT } from '../../components/Article';

export default function Post ({ seo, ...props }) {
	return (
		<>
			<Seo seo={seo} />
			<Article {...props} />
		</>
	);
}

export async function getStaticProps ({ params, ...ctx }) {
	const slug = params?.slug;

	const data = await fetchGql(gql`
        query GetPost ($slug: String) {
            entry (
                slug: [$slug]
                section: "post"
            ) {
                ... on post_default_Entry {
                    seo { ...Seo }
                    ...Article
                }
            }
        }
        ${SEO_FRAGMENT}
        ${ARTICLE_FRAGMENT}
	`, {
		slug,
	}, ctx);

	if (!data.entry)
		return { notFound: true };

	return {
		props: data.entry,
	};
}

export async function getStaticPaths () {
	const data = await fetchGql(gql`{
        entries (section: "post") {
            slug
        }
    }`);

	return {
		paths: data?.entries?.map?.(e => ({ params: e })) ?? [],
		fallback: 'blocking',
	};
}
